import React from 'react';

import { HtmlEntityType } from '../../../enums/HtmlEntityType';
import { DepartmentOption } from '../../../types/Department';
import { Option } from '../../../types/Option';
import { PilotId } from '../../../types/PilotId';
import { SharedSelectProps } from '../../../types/SharedSelectProps';
import { typedMemo } from '../../../utils/typedMemo';
import { Select } from '../Select';

interface Props<M> extends SharedSelectProps<PilotId, M> {
  /** Departments that will be available as options. */
  departments: DepartmentOption[];
  /** Enable select all */
  enableSelectAll?: boolean;
}

export const DepartmentSelect = typedMemo(
  <M extends boolean>({
    departments,
    value,
    onChange,
    onSearch,
    ...rest
  }: Props<M>) => {
    const options = departments.map(
      (dept: DepartmentOption): Option<PilotId> => {
        const deptPath = dept.path.join(` ${HtmlEntityType.RightArrow} `);
        return {
          value: dept.id,
          label: dept.name || '',
          leftIcon: 'department',
          description: `${deptPath} ${HtmlEntityType.RightArrow} ${dept.name}`,
        };
      },
    );

    return (
      <Select
        placeholder="Select department..."
        {...rest}
        options={options}
        value={value}
        onChange={onChange}
        onSearch={onSearch}
      />
    );
  },
);
